package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.StadiumW500Rounded: ImageVector
    get() {
        if (_stadiumW500Rounded != null) {
            return _stadiumW500Rounded!!
        }
        _stadiumW500Rounded = Builder(name = "StadiumW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(115.22f, 236.04f)
                verticalLineToRelative(-92.65f)
                quadToRelative(0.0f, -12.43f, 10.81f, -19.27f)
                quadToRelative(10.82f, -6.84f, 22.25f, -1.12f)
                lineToRelative(91.89f, 46.33f)
                quadToRelative(12.44f, 5.95f, 12.44f, 20.39f)
                quadToRelative(0.0f, 14.43f, -12.44f, 20.39f)
                lineToRelative(-91.89f, 46.32f)
                quadToRelative(-11.43f, 5.72f, -22.25f, -1.11f)
                quadToRelative(-10.81f, -6.84f, -10.81f, -19.28f)
                close()
                moveTo(722.63f, 236.04f)
                verticalLineToRelative(-92.65f)
                quadToRelative(0.0f, -12.43f, 10.82f, -19.27f)
                quadToRelative(10.81f, -6.84f, 22.25f, -1.12f)
                lineToRelative(91.89f, 46.33f)
                quadToRelative(12.43f, 5.95f, 12.43f, 20.39f)
                quadToRelative(0.0f, 14.43f, -12.43f, 20.39f)
                lineToRelative(-91.89f, 46.32f)
                quadToRelative(-11.44f, 5.72f, -22.25f, -1.11f)
                quadToRelative(-10.82f, -6.84f, -10.82f, -19.28f)
                close()
                moveTo(435.93f, 194.61f)
                verticalLineToRelative(-92.65f)
                quadToRelative(0.0f, -12.44f, 10.82f, -19.28f)
                quadToRelative(10.82f, -6.83f, 22.25f, -1.12f)
                lineToRelative(91.89f, 46.33f)
                quadToRelative(12.44f, 5.96f, 12.44f, 20.39f)
                quadToRelative(0.0f, 14.44f, -12.44f, 20.39f)
                lineTo(469.0f, 215.0f)
                quadToRelative(-11.43f, 5.72f, -22.25f, -1.12f)
                reflectiveQuadToRelative(-10.82f, -19.27f)
                close()
                moveTo(406.72f, 888.33f)
                quadToRelative(-144.31f, -7.29f, -240.06f, -41.86f)
                quadToRelative(-95.75f, -34.58f, -95.75f, -80.97f)
                lineTo(70.91f, 400.0f)
                quadToRelative(0.0f, -27.15f, 32.46f, -50.45f)
                quadToRelative(32.46f, -23.29f, 87.89f, -40.87f)
                quadToRelative(55.44f, -17.57f, 129.99f, -27.67f)
                quadToRelative(74.55f, -10.1f, 158.75f, -10.1f)
                reflectiveQuadToRelative(158.75f, 10.1f)
                quadToRelative(74.55f, 10.1f, 129.99f, 27.67f)
                quadToRelative(55.43f, 17.58f, 87.89f, 40.87f)
                quadToRelative(32.46f, 23.3f, 32.46f, 50.45f)
                verticalLineToRelative(365.5f)
                quadToRelative(0.0f, 47.15f, -96.37f, 80.99f)
                quadToRelative(-96.37f, 33.84f, -240.68f, 41.84f)
                quadToRelative(-14.24f, 1.0f, -24.09f, -8.86f)
                quadToRelative(-9.86f, -9.86f, -9.86f, -24.1f)
                verticalLineToRelative(-126.28f)
                horizontalLineToRelative(-76.18f)
                verticalLineToRelative(125.04f)
                quadToRelative(0.0f, 14.48f, -10.36f, 24.72f)
                quadToRelative(-10.35f, 10.24f, -24.83f, 9.48f)
                close()
                moveTo(480.0f, 436.41f)
                quadToRelative(93.41f, 0.0f, 160.92f, -10.78f)
                quadToRelative(67.51f, -10.78f, 108.56f, -24.83f)
                quadToRelative(-8.13f, -6.43f, -80.78f, -22.66f)
                quadToRelative(-72.66f, -16.23f, -188.7f, -16.23f)
                quadToRelative(-116.04f, 0.0f, -188.81f, 16.23f)
                quadToRelative(-72.78f, 16.23f, -80.67f, 22.66f)
                quadToRelative(41.05f, 14.05f, 108.56f, 24.83f)
                quadToRelative(67.51f, 10.78f, 160.92f, 10.78f)
                close()
                moveTo(350.91f, 791.37f)
                verticalLineToRelative(-62.28f)
                quadToRelative(0.0f, -37.79f, 26.61f, -64.39f)
                quadToRelative(26.61f, -26.61f, 64.39f, -26.61f)
                horizontalLineToRelative(76.18f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                quadToRelative(26.61f, 26.6f, 26.61f, 64.39f)
                verticalLineToRelative(62.28f)
                quadToRelative(74.5f, -7.76f, 122.51f, -22.07f)
                quadToRelative(48.01f, -14.3f, 66.49f, -25.82f)
                verticalLineToRelative(-263.83f)
                quadToRelative(-55.48f, 22.0f, -136.69f, 34.88f)
                quadToRelative(-81.2f, 12.88f, -181.4f, 12.88f)
                reflectiveQuadToRelative(-181.4f, -12.88f)
                quadToRelative(-81.21f, -12.88f, -136.69f, -34.88f)
                verticalLineToRelative(263.83f)
                quadTo(180.39f, 755.0f, 228.4f, 769.3f)
                quadToRelative(48.01f, 14.31f, 122.51f, 22.07f)
                close()
                moveTo(480.0f, 635.63f)
                close()
            }
        }
        .build()
        return _stadiumW500Rounded!!
    }

private var _stadiumW500Rounded: ImageVector? = null
